module.exports = "https://static.moomoo.com/components/common-reservation/images/dialog_niuniu.181539c10f.png";